import { Owner } from './billing-letter/Owner.model';
import { Address } from './Address.model';
import { CompanyGroup } from './CompanyGroup.model';
import { GroupDivision } from '../shared/enums/GroupDivision';
import { GroupOrigin } from '../shared/enums/GroupOrigin';
import { ExternalReferenceFinancial } from './ExternalReference.model';
import { Payment } from './Payment.model';
import * as _ from 'lodash';
import { CompanyContract } from './CompanyContract.model';
import { Industry } from './Industry.model';

export class Company {
    _id: string;
    active: boolean;
    companyName: string;
    name: string;
    group: GroupDivision = 0; // REMOVER
    divisions: any = new Array<any>();
    created: Date;
    changed: Date;
    origin: GroupOrigin = 0;
    phones: String[] = new Array<String>();
    emails: String[] = new Array<String>();
    cnpj: String;
    validated: Boolean;
    inscriptionEstadual: String;
    inscriptionMunicipal: String;
    x3Id: String;
    integrated: Boolean;
    description: String;
    externalReference: ExternalReferenceFinancial = null;
    companyGroup: CompanyGroup = new CompanyGroup();
    industry: Industry = new Industry();
    companyContractType: any = new Array<any>();
    address: Address = new Address();
    payment: Payment = new Payment();
    sapCardCode: String;
    generatedContract: boolean;
    typeContract: String = '';
    subscriber: String;
    subscriberEmail: String;
    financialEmail: String;
    isCustomer: Boolean;
    defaultItems: String[];
    companyTemporaryId: String = '';
    start: string;
    end: string;
    contracts: CompanyContract[] = new Array<CompanyContract>();
    purchaseRecurring: boolean = false;
    legalApproved: boolean = false;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadCompanyForGrid(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.group)
            this.group = r.group;

        if (r.companyGroup)
            this.companyGroup = r.companyGroup;

        if (r.industry)
            this.industry = r.industry;

        if(r.divisions)
            this.divisions = r.divisions;

        if (r.contracts)
            for (let c of r.contracts) {
                let contract = new CompanyContract();
                contract.populateFromServer(c);
                this.contracts.push(contract);
            }

        if (r.start)
            this.start = r.start;

        if (r.end)
            this.end = r.end;

        if (r.companyName)
            this.companyName = r.companyName;

        if (r.cnpj)
            this.cnpj = r.cnpj;

        if (r.active)
            this.active = r.active;

        if (r.externalReference) {
            this.externalReference = new ExternalReferenceFinancial();
            this.externalReference.loadExternalReference(r.externalReference)
        }

        if(r.isCustomer){
            this.isCustomer = r.isCustomer;
        }

        if(r.sapCardCode){
            this.sapCardCode = r.sapCardCode;
        }

        if(r.subscriber){
            this.subscriber = r.subscriber;
        }

        if (r.purchaseRecurring)
            this.purchaseRecurring = r.purchaseRecurring;

        if (r.legalApproved)
            this.legalApproved = r.legalApproved;
    }

    loadToEdit(r: any) {
        if (r._id)
            this._id = r._id;

        if (r.active)
            this.active = r.active;

        if (r.companyName)
            this.companyName = r.companyName;

        if (r.name)
            this.name = r.name;

        if (r.group)
            this.group = r.group;

        if (r.divisions) {
            for(let divisionData of r.divisions) {
                let d = { division: 0, owner: new Owner(), manager: new Owner() }
                d.division = divisionData.division;
                d.owner.populate(divisionData.owner);
                d.manager.populate(divisionData.manager);
                this.divisions.push(d);
            }
        }

        if (r.contracts) {
            for (let c of r.contracts) {
                let contract = new CompanyContract();
                contract.populateFromServer(c);
                this.contracts.push(contract);
            }
        }

        if (r.start)
            this.start = r.start;

        if (r.end)
            this.end = r.end;

        if (r.created)
            this.created = r.created;

        if (r.changed)
            this.changed = r.changed;

        if (r.origin)
            this.origin = r.origin;

        if (r.phones)
            this.phones = r.phones;

        if (r.emails)
            this.emails = r.emails;

        if (r.cnpj)
            this.cnpj = r.cnpj;

        if (r.validated)
            this.validated = r.validated;

        if (r.inscriptionEstadual)
            this.inscriptionEstadual = r.inscriptionEstadual;

        if (r.inscriptionMunicipal)
            this.inscriptionMunicipal = r.inscriptionMunicipal;

        if (r.x3Id)
            this.x3Id = r.x3Id;

        if (r.integrated)
            this.integrated = r.integrated;

        if (r.description)
            this.description = r.description;

        if (r.externalReference) {
            this.externalReference = new ExternalReferenceFinancial();
            this.externalReference.loadExternalReference(r.externalReference);
        }

        if(r.companyGroup)
            this.companyGroup.loadGroups(r.companyGroup);

        if(r.industry)
            this.industry.loadIndustry(r.industry);

        if(r.address)
            this.address.loadToEdit(r.address);

        if (r.payment)
            this.payment.loadToEdit(r.payment);

        if (r.sapCardCode)
            this.sapCardCode = r.sapCardCode;

        if(r.generatedContract)
            this.generatedContract = r.generatedContract;

        if(r.typeContract)
            this.typeContract = r.typeContract;

        if(r.subscriber)
            this.subscriber = r.subscriber;

        if(r.subscriberEmail)
            this.subscriberEmail = r.subscriberEmail;

        if(r.financialEmail) {
            this.financialEmail = r.financialEmail;
        }

        if (r.hasOwnProperty('isCustomer')) {
            this.isCustomer = r.isCustomer;
        }

        if (r.defaultItems)
            this.defaultItems = r.defaultItems;

        if(r.companyTemporaryId)
            this.companyTemporaryId = r.companyTemporaryId;

        if(r.purchaseRecurring)
            this.purchaseRecurring = r.purchaseRecurring;

        if(r.legalApproved)
            this.legalApproved = r.legalApproved;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Company.model.ts